import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { Icon } from "@/components/ui/Icon";
import { ROUTES } from "@/constants/routes";
import { restoreAuthenticatedSession } from "@/lib/restoreAuthenticatedSession";

export const PublicOnlyGuard = () => {
  const navigate = useNavigate();
  const [isCheckingSession, setIsCheckingSession] = useState(true);

  useEffect(() => {
    let isMounted = true;

    restoreAuthenticatedSession().then((restored) => {
      if (!isMounted) return;

      if (restored) {
        navigate(ROUTES.dashboard, { replace: true });
        return;
      }

      setIsCheckingSession(false);
    });

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  if (isCheckingSession) {
    return (
      <div className="bg-background flex h-screen w-full items-center justify-center">
        <Icon
          name="spinner"
          className="size-6 animate-spin text-neutral-500"
        />
      </div>
    );
  }

  return <Outlet />;
};
